import React from 'react';
import X from '../../assets/icons/new_icon/x.svg';
interface Props {
  onClose: any;
}
function DgModal({ onClose }: Props) {
  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='address_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      role='dialog'
      aria-labelledby='quoteModalLabel'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div
        className='modal-dialog modal-dialog-centered modal-lg'
        role='document'
      >
        <div className='modal-content' style={{ borderRadius: '8px' }}>
          <div className='modal-header d-flex w-100 justify-content-between px-4 py-2'>
            <h3 className='newubbemodalheading  mt-3'>
              Information & Limitations
            </h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div className='modal-body pt-0 px-1'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='form-group text-left'>
                  <label className='col-sm-12  col-form-label globalInputLabel my-auto'>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12'>
                        <p className='boldglobaltext mb-0   ms-4'>
                          Information
                        </p>
                        <ul
                          className='list-style boldglobaltext '
                          style={{ fontWeight: '300' }}
                        >
                          <li>
                            Below is a list of Dangerous Goods categories
                            available for transport by selected carriers on
                            selected routes
                          </li>
                          <li>
                            Shipping a Dangerous Good not listed below? Send us
                            a request to customerservice@ubbe.com and we will
                            see if we can help
                          </li>
                        </ul>
                      </div>
                      <div className='col-sm-12 col-md-12'>
                        <p className='boldglobaltext mb-0   ms-4'>
                          Limitations
                        </p>
                        <ul
                          className='list-style boldglobaltext '
                          style={{ fontWeight: '300' }}
                        >
                          <li>Excepted quantities are not supported</li>
                          <li>Exempt UNs are not supported</li>
                          <li>
                            Air Waybill Packing Instruction messages are not
                            supported
                          </li>
                          <li>
                            Air Waybill Special Provisions messages are not
                            supported
                          </li>
                          <li>Radioactive Dangerous Goods are not supported</li>
                        </ul>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DgModal;
